import { ALL_STATIC_DEMO_DATA, DEMO_MAPPER } from '../../../constants/reading/DemoModeConstants';
import request from '../../request';
import { PDF_HEADERS, PDF_RESPONSE_TYPE } from '../../../constants/shared/ApiConstants';

const DEMO_DATA_PATH = '/classroom-reports-resources/';

class StaticContentClient {
    static getUrls() {
        return ALL_STATIC_DEMO_DATA.map(file => `${DEMO_DATA_PATH}${file}`);
    }

    static async getAllDemoData() {
        try {
            const demoDataMap = {};
            const promises = this.getUrls().map(fileUrl => request.get(fileUrl));
            const responses = await Promise.all(promises);

            Object.keys(DEMO_MAPPER).forEach((key, i) => {
                const title = DEMO_MAPPER[key];
                demoDataMap[title] = responses[i];
            });
            return demoDataMap;
        } catch (error) {
            throw new Error(`Failed to retrieve demo data: ${error.message}`);
        }
    }

    static getPdfDemoData = async url => {
        return request.get(`${DEMO_DATA_PATH}${url}`, {
            responseType: PDF_RESPONSE_TYPE,
            headers: PDF_HEADERS,
        });
    };
}

export default StaticContentClient;
